import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import LoadingAdapter from "libs/utils/LoadingAdapter";
import SettingService from "services/SettingService";

let initialState = { list: [] };

export const searchLocation = createAsyncThunk(
  "searchLocation/address",
  async ({typeSearch, keyword }) => {
    const response = await SettingService.searchLocation(typeSearch, keyword);
    return response?.results;
  }
);

const searchLocationSlice = createSlice({
  name: "searchLocation",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    LoadingAdapter.applyAsyncBuilder(searchLocation, builder, ["list"]);
  },
});

export const selectSearchLocation = (state) => state.searchLocation;

export default searchLocationSlice.reducer;
